import { ArrowRight } from "lucide-react";

/**
 * Persistent "Download free" bar pinned to the bottom of the viewport on
 * mobile. Hidden ≥ md so desktop layouts aren't affected.
 *
 * Removes the "where do I get the app?" friction for users scrolling
 * through the marketing root on a phone — even after they leave the
 * hero CTA above-the-fold, the install path stays one tap away.
 *
 * Routes through /get (same as every other Download CTA) so the
 * serveGetRedirect CF handles UA-aware platform routing.
 */
export function StickyMobileCta() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#253448] bg-[#0C1222]/95 px-4 py-3 backdrop-blur-md md:hidden">
      <a
        href="/get"
        className="group flex w-full items-center justify-center gap-2 rounded-xl bg-[#4DB8C7] px-6 py-3 text-base font-semibold text-[#0C1222] shadow-[0_0_20px_rgba(77,184,199,0.25)] transition-all active:scale-[0.98]"
      >
        Download free
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
      </a>
    </div>
  );
}
